import React, { useContext, useEffect, useRef, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';

import InputField from 'components/Form/InputField';
import Row from 'components/Grid/Row';
import Col from 'components/Grid/Col';
import { ButtonContainer, ButtonMiradorOrange } from 'components/Button';
import Loader from 'components/Loader';

import Colors from 'constants/Colors';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext, GlobalOperationContext } from 'store/context';
import { ButtonContent } from './styles';

export default function Page5({ match }) {
  //console.log(props);

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const operationContext = useContext(GlobalOperationContext);
  const idOperation = match.params.idOperation;
  const history = useHistory();
  const formikRef = useRef(null);

  // main execution
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const getName = () => {
    const name = operationContext.add2_request.personQuestionnaire.find(qst => qst.idQuestion === 189).textQuestionAnswer;
    return name.split(' ', 1);
  };

  let messageHeader = () => {
    return (
      <><div>
        <h4 style={{ fontWeight: "bold" }}>
          Planeje sua aposentadoria de verdade
          <br />
          ou invista para conquistar
          <br />
          o que quer no futuro
        </h4>
      </div>
      </>
    );
  }

  let messageBodyTop = () => {
    return (
      <><div>
        <h5 style={{ fontWeight: "bold" }}>
          <div style={{ textTransform: "capitalize", display: "inline-flex" }}>{getName()}</div> digite aqui o código de verificação
          <br />
          que acabamos de te enviar via e-mail.
        </h5>
      </div>
      </>
    );
  }

  let messageBodyBottom = () => {
    return (
      <div>
        <h6 style={{ cursor: "pointer" }}
          onClick={() => {
            history.push(`/embed/page4/${idOperation}`);
          }}>
          Quero trocar meu e-mail
        </h6>
      </div>
    );
  }

  const handleResend = () => {
    loading.start();
    console.log("auth context-> ", authContext.token)
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestAddAction5(idOperation, null, true)
      .then((response) => response.json())
      .then((data) => {
        if (data.ret_code !== 200) {
          console.log(data.ret_msg);
          mc.error("Erro ao enviar o Código, tente novamente")
          return;
        };
        mc.success("Código Re-enviado!")
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(()=>{
        loading.stop();
      });
  }

  useEffect(() => {
    //loading.start();
    //loading.stop();
  }, [])

  const handleSubmit = (values) => {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestAddAction5(idOperation, values.verificationCode, false)
      .then(data => data.json())
      .then(response => {
        if (response.ret_code !== 200) {
          mc.error("Código Inválido")
          loading.stop();
          return;
        }
        loading.stop();
        history.push(`/embed/Page6/${idOperation}`);
      })
      .cath(error => {
        console.log(JSON.stringify(error));
        mc.error("Erro ao processar solicitação")
      })
      .finally(()=>{
        loading.stop();
      });
  };

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{}}
      enableReinitialize={true}
      onSubmit={(values) => handleSubmit(values)}
    >
      {({ handleSubmit }) => (
        <Form>
          <Row style={{ textAlign: "center", justifyContent: "center" }}>{messageHeader()}</Row>
          <Row><hr style={{ width: "100%", boxShadow: "rgba(0, 0, 0, 0.05) 1px 3px 5px 1px" }} /></Row>
          <Row style={{ textAlign: "center", justifyContent: "center" }}>{messageBodyTop()}</Row>
          <Row>
            <Col style={{ textAlign: "-webkit-center" }}>
              <Field
                style={{ width: "50%" }}
                name="verificationCode"
                isRequired={true}
                component={InputField}
                onChange={(value) => { value.length > 7 ? handleSubmit() : console.log(value) }}
              />
            </Col>
          </Row>
          <Row style={{ textAlign: "center", justifyContent: "center" }}>
            <h5 style={{ fontWeight: "normal" }}>Não recebeu o código em 30 segundos?<br />Clique em reenviar e pronto!</h5>
          </Row>

          <ButtonContainer style={{ justifyContent: "center" }}>
            <ButtonContent>
              <ButtonMiradorOrange
                primary
                onClick={() => handleResend()}
              >REENVIAR
              </ButtonMiradorOrange>
            </ButtonContent>
          </ButtonContainer>
          <Row style={{ textAlign: "center", justifyContent: "center" }}>{messageBodyBottom()}</Row>
        </Form>
      )}
    </Formik>
  )
}